import { configureStore } from "@reduxjs/toolkit";
import QuesRed from './reducers/QuesRed';

const store = configureStore({
  reducer: {
    QuesRed,  // This should be 'reducers' not 'reducres'
  }
});

export default store;
